import { decodeHTML } from 'entities';
import React from 'react';
import { decodeHTMLEntities, formatNumberWithCommas } from '../../utils';

const ResumePage = ({
    data,
    resumeSchoolInfo,
    resumeCareerInfo,
    resumeLicenseInfo,
    resumeActiveInfo,
    desiredWorkingConditions = true,
}) => {
    return (
        <>
            {desiredWorkingConditions ? (
                <>
                    <div className="resume__tit-box">
                        <h4 className="resume__tit2">희망근무조건</h4>
                    </div>
                    <div className="resume__block">
                        <table className="rsm-dtl__table">
                            <tbody>
                                <tr>
                                    <th>희망업무</th>
                                    <td>{data?.resumeClass}</td>
                                </tr>
                                <tr>
                                    <th>소지자격증</th>
                                    <td>{data?.resumeLicense}</td>
                                </tr>
                                <tr>
                                    <th>희망 근무형태</th>
                                    <td>{data?.resumeForm}</td>
                                </tr>
                                <tr>
                                    <th>희망 근무지역</th>
                                    <td>
                                        {[
                                            { si: data.resumeRegionSi1, gu: data.resumeRegionGu1 },
                                            { si: data.resumeRegionSi2, gu: data.resumeRegionGu2 },
                                            { si: data.resumeRegionSi3, gu: data.resumeRegionGu3 },
                                        ]
                                            .filter((item) => item.si && item.gu)
                                            .map((item, index, array) => (
                                                <React.Fragment key={index}>
                                                    {item.si} &gt; {item.gu}
                                                    {index < array.length - 1 && ', '}
                                                </React.Fragment>
                                            ))}
                                    </td>
                                </tr>
                                <tr>
                                    <th>희망급여</th>
                                    <td>
                                        {data?.resumePay === '직접입력'
                                            ? formatNumberWithCommas(data?.resumePayEtc)
                                            : data?.resumePay}
                                    </td>
                                </tr>
                                <tr>
                                    <th>희망직급</th>
                                    <td>{data?.resumePosition}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            ) : (
                ''
            )}
            <div className="resume__tit-box">
                <h4 className="resume__tit2">학력사항</h4>
            </div>
            <div className="resume__block">
                <table className="rsm-dtl__table">
                    <tbody>
                        <tr>
                            <th>최종학력</th>
                            <td>
                                {data?.resumeGrade && (
                                    <>
                                        {data.resumeGrade === '001' && '고등학교 졸업'}
                                        {data.resumeGrade === '009' && '전문대/대학 졸업'}
                                        {data.resumeGrade === '013' && '대학원 이상 졸업'}
                                    </>
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table className="rsm-dtl__table2">
                    <thead>
                        <tr>
                            <th style={{ width: '24%' }}>재학기간</th>
                            <th>학교명</th>
                            <th style={{ width: '15%' }}>전공</th>
                            <th style={{ width: '15%' }}>학점</th>
                        </tr>
                    </thead>
                    <tbody>
                        {resumeSchoolInfo && resumeSchoolInfo.length ? (
                            resumeSchoolInfo.map((item, index) => {
                                return (
                                    item?.name !== '' && (
                                        <tr key={`school-${index}`}>
                                            <td>
                                                {item?.from !== '.' && item?.to === '.'
                                                    ? `${item?.from}`
                                                    : item?.from === '.' && item?.to === '.'
                                                        ? ''
                                                        : `${item?.from} ~ ${item?.to}`}
                                                <br />
                                                <span className="grdt">
                                                    {index === 0 ? '졸업' : item?.status ? item?.status : ''}
                                                </span>
                                            </td>
                                            <td>{item?.name}</td>
                                            <td>{item?.major ? item?.major : ''}</td>
                                            <td>{item?.gpa ? `${item?.gpa} / ${item?.gpaScale}` : ''}</td>
                                        </tr>
                                    )
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={5}>데이터 없습니다</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className="resume__tit-box">
                <h4 className="resume__tit2">경력사항</h4>
            </div>
            <div className="resume__block">
                <table className="rsm-dtl__table">
                    <tbody>
                        <tr>
                            <th>경력사항</th>
                            <td>
                                {data?.resumeCareer === '009'
                                    ? `경력 (${data?.resumeCareerYear ? data?.resumeCareerYear : ''}년)`
                                    : '신입'}
                            </td>
                        </tr>
                    </tbody>
                </table>
                {data?.resumeCareer === '009' && (
                    <>
                        <table className="rsm-dtl__table2">
                            <thead>
                                <tr>
                                    <th className="wd180">근무기간</th>
                                    <th colSpan={2}>상세경력</th>
                                </tr>
                            </thead>
                            {resumeCareerInfo && resumeCareerInfo ? (
                                resumeCareerInfo.map((item, index) => {
                                    return (
                                        <tbody key={`career-${index}`}>
                                            <tr>
                                                <td rowSpan="4">
                                                    {item?.working === 'N'
                                                        ? `${item?.from} ~ ${item?.to}`
                                                        : item?.working === 'Y'
                                                            ? `${item?.from} ~ 현재`
                                                            : ''}
                                                    <br />
                                                    <span className="grdt">
                                                        {item?.working === 'Y' ? '재직중' : '퇴사'}
                                                    </span>
                                                </td>
                                                <th> 치과명</th>
                                                <td>{item?.businessName}</td>
                                            </tr>
                                            <tr>
                                                <th>근무지역/직책</th>
                                                <td>
                                                    {item?.location} / {item?.respon}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>담당업무</th>
                                                <td>{item.etc && decodeHTMLEntities(decodeHTML(item?.etc))}</td>
                                            </tr>
                                            {item?.working === 'N' && (
                                                <tr>
                                                    <th>퇴사사유</th>
                                                    <td>
                                                        {item.reasonLeave &&
                                                            decodeHTMLEntities(decodeHTML(item?.reasonLeave))}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    );
                                })
                            ) : (
                                <tbody></tbody>
                            )}
                        </table>
                        <table className="rsm-dtl__table mt20">
                            <tbody>
                                <tr>
                                    <th className="wd180">
                                        기타 경력사항 및<br />
                                        기술서
                                    </th>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </>
                )}
            </div>
            {resumeLicenseInfo && resumeLicenseInfo.length > 0 && resumeLicenseInfo[0].name !== '' && (
                <>
                    <div className="resume__tit-box">
                        <h4 className="resume__tit2">자격/면허정보</h4>
                    </div>
                    <div className="resume__block">
                        <table className="rsm-dtl__table2 rsm-dtl__table2--mt0">
                            <thead>
                                <tr>
                                    <th>구분</th>
                                    <th>자격증/면허증</th>
                                    <th>발행처/발행기관</th>
                                    <th>취득일</th>
                                </tr>
                            </thead>
                            {resumeLicenseInfo.map((item, index) => {
                                return (
                                    <tbody key={`license-${index}`}>
                                        <tr>
                                            <td>{item?.licenseType}</td>
                                            <td>{item?.name}</td>
                                            <td>{item?.agency}</td>
                                            <td>
                                                {item?.yearMonth.split('-')[1]
                                                    ? item?.yearMonth.split('-')[0] +
                                                    ' ~ ' +
                                                    item?.yearMonth.split('-')[1]
                                                    : item?.yearMonth.split('-')[0]}
                                            </td>
                                        </tr>
                                    </tbody>
                                );
                            })}
                        </table>
                    </div>
                </>
            )}
            {resumeActiveInfo && resumeActiveInfo.length > 0 && resumeActiveInfo[0].yearMonthStart !== '.' && (
                <>
                    <div className="resume__tit-box">
                        <h4 className="resume__tit2">기타활동/사회경험</h4>
                    </div>
                    <div className="resume__block">
                        <table className="rsm-dtl__table2 rsm-dtl__table2--mt0">
                            <thead>
                                <tr>
                                    <th className="wd251">활동기간</th>
                                    <th className="wd120">활동종류</th>
                                    <th>상세활동</th>
                                </tr>
                            </thead>
                            {resumeActiveInfo.map((item, index) => {
                                return (
                                    <tbody key={`activity-${index}`}>
                                        <tr>
                                            <td rowSpan={3}>
                                                {item?.yearMonthStart} ~ {item?.yearMonthEnd}
                                            </td>
                                            <th>활동종류</th>
                                            <td>{item?.type}</td>
                                        </tr>
                                        <tr>
                                            <th>기관/장소</th>
                                            <td>{item?.place}</td>
                                        </tr>
                                        <tr>
                                            <th>활동내용</th>
                                            <td>{decodeHTMLEntities(decodeHTML(item?.content))}</td>
                                        </tr>
                                    </tbody>
                                );
                            })}
                        </table>
                    </div>
                </>
            )}

            <div className="resume__tit-box">
                <h4 className="resume__tit2">자기소개서</h4>
            </div>
            <div className="resume__block">
                <p
                    className="rsm-dtl__intro"
                    dangerouslySetInnerHTML={{
                        __html: data?.resumeContent ? decodeHTML(data?.resumeContent) : '자기소새서 입력',
                    }}
                ></p>
            </div>
        </>
    );
};
export default ResumePage;
